import { IntegrationsHubSettingGroups } from "../../integrations-hub/groups";
import { defineSettingsProvider } from "../provider";
import type { SettingGroupDefinition } from "../types";

export const IntegrationsHubCatalogProvider = defineSettingsProvider({
  name: "integrations hub",
  groups: IntegrationsHubSettingGroups,
  definitions: [],
});

export const IntegrationsHubCatalogGroups =
  IntegrationsHubCatalogProvider.groups satisfies readonly SettingGroupDefinition[];
